// Les types de demande et les événements que le portail sait composer. Un
// type que le serveur ajoute demain n'est pas dans ces listes : il retombe sur
// le texte français que le serveur a écrit, plutôt que sur une clé brute.
const DEMANDES = ['conge', 'avance', 'acompte', 'pret', 'note_frais', 'attestation', 'heures_sup'];
const EVENEMENTS = ['demande_deposee', 'demande_approuvee', 'demande_refusee', 'attestation_remise',
  // Yros/Kavero#468 : la chaîne de validation.
  'demande_a_valider', 'demande_validee_manager'];

/**
 * Le titre et le corps d'une notification, dans la langue de l'écran
 * (Yros/Kavero#21).
 *
 * Le serveur écrit en français au moment de l'événement ; la langue du portail
 * vit dans le navigateur. On compose donc depuis ce que le serveur livre :
 * `type`, `demande_type`, le nom du salarié (`acteur`) et le motif de refus
 * (`motif`, un texte libre de la RH, jamais traduit). Ce qu'on ne sait pas
 * composer garde `titre` et `corps` du serveur.
 *
 * @param {object} notification une entrée de `GET /api/rh/notifications`
 * @param {function} t le `t` de `useTranslation()`
 */
export const texteNotification = (notification, t) => {
  const { type, demande_type: demandeType, acteur, motif } = notification;
  const repli = { titre: notification.titre, corps: notification.corps };
  if (!EVENEMENTS.includes(type) || !DEMANDES.includes(demandeType)) return repli;

  const demande = t(`cloche.demandes.${demandeType}`);
  // Le type de demande peut ouvrir le titre (« Demande de congé à valider ») :
  // la majuscule ne se met pas dans la traduction d'un nom commun.
  const brut = t(`cloche.evenements.${type}.titre`, { demande });
  const titre = brut.charAt(0).toUpperCase() + brut.slice(1);
  if (type === 'demande_deposee' || type === 'demande_a_valider' || type === 'demande_validee_manager') {
    // Une ligne écrite avant les champs structurés n'a pas d'acteur.
    return { titre, corps: acteur ? t(`cloche.evenements.${type}.corps`, { acteur }) : notification.corps };
  }
  if (type === 'demande_refusee') return { titre, corps: motif || notification.corps || '' };
  return { titre, corps: '' };
};
